var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.actualAdIndex)?_c('AdUnit',{attrs:{"adPosition":'inlist_' + _vm.actualAdIndex}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }